import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ClaimCampaignVoucherRequest, ValidateCampaignVoucherRequest } from '../models/voucher.model';
import { MobilePhoneProduct } from '../models/mobilephone-product';
import { CustomerProductMobilePhoneSelectors } from '../states/customer-product-mobilephone/customer-product-mobilephone.selectors';
import { ShoppingCartSelectors } from '../states/shopping-cart/shopping-cart.selectors';
import { Price } from '@app/shared/models/price.model';

@Injectable({
  providedIn: 'root',
})
export class VoucherHelperService {
  private store = inject(Store);

  buildClaimCampaignVoucherRequest(voucherCode: string): ClaimCampaignVoucherRequest {
    const claimRequest: ClaimCampaignVoucherRequest = {
      voucherCode,
      purchasedDeviceGtins: this.getPurchasedDeviceGtins(),
      totalPurchasePrice: this.getTotalPurchasePrice(),
    };

    return claimRequest;
  }

  buildValidateCampaignVoucherRequest(): ValidateCampaignVoucherRequest {
    const validateRequest: ValidateCampaignVoucherRequest = {
      purchasedDeviceGtins: this.getPurchasedDeviceGtins(),
      totalPurchasePrice: this.getTotalPurchasePrice(),
    };

    return validateRequest;
  }

  private getPurchasedDeviceGtins(): string[] {
    const allMobileProducts = this.store.selectSnapshot<MobilePhoneProduct[]>(
      CustomerProductMobilePhoneSelectors.mobilePhoneProducts
    );
    return allMobileProducts.map(product => product.gtin);
  }

  private getTotalPurchasePrice(): Price {
    const totalUpfrontPrice = this.store.selectSnapshot<number>(ShoppingCartSelectors.shoppingCartPayNowPrice);
    return new Price(totalUpfrontPrice, null, null); // Only the "including VAT" amount is relevant here
  }
}
